import React, { useState } from 'react';
import { resetReonomy } from '/imports/api/devtools';
import { toastOnError } from '/imports/ui/utils';
import { DevToolSection } from '/imports/ui/DevToolSection';

/** Dev tool section that hard-resets the Reonomy integration. */
export const DevToolReonomyReset = () => {
  const [loading, setLoading] = useState(false);
  /** Triggers a hard reset of the Reonomy integration. */
  const run = toastOnError(async () => {
    setLoading(true);
    try {
      await resetReonomy.call({ hard: true });
    } finally {
      setLoading(false);
    }
  });
  return (
    <DevToolSection
      title="Reonomy Reset"
      description="Do a hard reset of the Reonomy integration, forcing a new instance and login"
      onRun={() => run()}
      loading={loading}
    />
  );
};

